import { gmiRequest } from "actions/request";
import { actions, services } from "@ehi/global-marketing-interface";

/**
 * @name associateReservation
 * @desc Dispatcher for the GMA request for associate unauth reservation to profile
 * @returns {Function}
 */
export const associateReservation = (payload) => (dispatch) =>
    dispatch(
        gmiRequest({
            action: actions.request({
                service: services.gma.reservations.associateAll,
                data: {
                    params: payload,
                },
            }),
            loadingOverlay: true,
        })
    );